import React, { useState } from 'react';
import { Modal, Form, Input, Button, Tabs } from 'antd';
import IntlMessages from '../../components/IntlMessage';
import { useIntl } from 'react-intl';

import tourApi from '../../api/tour';
// import config from '../../config';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import langsApi from '../../api/langs';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

export default function LanguageForm(props) {
  const { onClose, currentData, open, code } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  //console.log("?",loading)
  const intl = useIntl();

  const handleSubmit = () => {
    setLoading(true);

    form
      .validateFields()
      .then((values) => {
        let data = {};
        data.record_id = currentData.id;
        data.table = 'destinations';
        data.code = code.code;
        data.fields = [];

        Object.entries(values).forEach(([key, value]) => {
          data.fields.push({ field: key, content: value.toString() });
        });

        if (Array.isArray(values.meta_data)) {
          data.fields = data.fields.concat(
            values.meta_data.map((item) => {
              const field = Object.keys(item)[0] || '';
              const content = Object.values(item)[0] || '';
              return { field, content };
            })
          );
        }

        if (currentData) {
          langsApi
            .createLanguage(data)
            .then(() => {
              setLoading(false);
              handleCancel();
              props.onReload();
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
            });
        }
      })
      .catch(() => setLoading(false));
  };

  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };

  const handleCancel = () => {
    //form.resetFields();
    onClose();
  };

  let initialValue = {
    ...currentData,
    ...(currentData && currentData.language && currentData.language.length > 0
      ? {
          title:
            currentData &&
            currentData.language.find((item) => item.field.includes('title'))
              ? currentData.language.find((item) =>
                  item.field.includes('title')
                ).content
              : '',
          description:
            currentData &&
            currentData.language.find((item) =>
              item.field.includes('description')
            )
              ? currentData.language.find((item) =>
                  item.field.includes('description')
                ).content
              : '',
        }
      : {
          title: currentData && currentData.title ? currentData.title : '',
          description:
            currentData && currentData.description
              ? currentData.description
              : '',
          cover_image:
            currentData && currentData.cover_image
              ? currentData.cover_image
              : '',
          country_id:
            currentData && currentData.country && currentData.country.id
              ? currentData.country.id
              : '',
          parent_id:
            currentData && currentData.parentId ? currentData.parentId : null,
          longitude:
            currentData && currentData.longitude ? currentData.longitude : '',
          latitude:
            currentData && currentData.latitude ? currentData.latitude : '',
          status: currentData && currentData.status ? 1 : 0,
          featured: !!(currentData && currentData.featured),
        }),
  };

  const tabItems = [
    {
      key: '1',
      forceRender: true,
      label: <IntlMessages id="global.tour_option" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessages id="global.title" />}
            name="title"
            rules={[
              {
                required: true,
                message: <IntlMessages id="global.requiredfield" />,
              },
            ]}
          >
            <Input />
          </Form.Item>
          {/* <Form.Item name="status" label={<IntlMessages id="global.status" />}>
            <Radio.Group>
              <Radio value={0}>
                <IntlMessages id="global.inactive" />
              </Radio>
              <Radio value={1}>
                <IntlMessages id="global.active" />
              </Radio>
            </Radio.Group>
          </Form.Item> */}
        </>
      ),
    },
    {
      key: '2',
      forceRender: true,
      label: <IntlMessages id="global.description" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessages id="global.description" />}
            name="description"
            rules={[
              {
                required: false,
              },
            ]}
            valuePropName="data"
            getValueFromEvent={(event, editor) => {
              const data = editor.getData();
              // console.log({ event, editor, data });
              return data;
            }}
          >
            <CKEditor editor={ClassicEditor} />
          </Form.Item>
        </>
      ),
    },
  ];

  return (
    <Modal
      title={
        currentData ? (
          <>
            <IntlMessages id="global.edit" /> - {code.image_name}
          </>
        ) : (
          <IntlMessages id="global.add" />
        )
      }
      open={open}
      destroyOnClose={true}
      onCancel={handleCancel}
      width="60%"
      onOk={handleSubmit}
      footer={[
        <Button key="back" type="default" onClick={handleCancel}>
          {<IntlMessages id="global.cancel" />}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          loading={loading}
          onClick={handleSubmit}
        >
          {<IntlMessages id="global.save" />}
        </Button>,
      ]}
    >
      <Form
        {...layout}
        form={form}
        initialValues={initialValue}
        labelAlign="left"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}
      >
        <Tabs defaultActiveKey="1" items={tabItems}></Tabs>
      </Form>
    </Modal>
  );
}
